<template>
  <img ref="imgRef" async :alt="alt" :src="src" :width="imgWidth > 0 ? imgWidth : ''" :height="imgHeight" v-bind="showTitle ? { title } : { alt }" />
</template>

<script>
import { ref, onMounted } from "vue";
export default {
  props: {
    alt: {
      type: String,
    },
    src: {
      type: String,
    },

    title: {
      type: String,
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
  },
  name: "Image",
  components: {},
  setup(props) {
    const imgWidth = ref("");
    const imgHeight = ref("");
    const imgRef = ref(null);

    onMounted(() => {
      if (imgRef.value) {
        imgWidth.value = imgRef.value.clientWidth;
        imgHeight.value = imgRef.value.clientHeight;
      }
    });
    return {
      imgWidth,
      imgHeight,
      imgRef,
    };
  },
};
</script>
